import {
  isImagePlaceholderContent,
  isSharePlaceholderContent,
  isVideoPlaceholderContent,
} from "@/lib/chat-message-caption";
import { parseCatalogOrderDisplay } from "@/lib/whatsapp-catalog-order";
import {
  isInteractivePlaceholderContent,
  parseInboundInteractiveReply,
  parseOutboundCarouselDisplay,
  parseOutboundInteractive,
  parseOutboundPollDisplay,
} from "@/lib/whatsapp-interactive-message";

export type MessageTextLayout = "inline" | "block" | "none";

type MessageLike = {
  content?: string | null;
  metadata?: Record<string, unknown> | null;
  deleted_at?: string | null;
};

/** Define se o horário fica inline no texto, abaixo do bubble ou omitido. */
export function getMessageTextLayout(message: MessageLike): MessageTextLayout {
  if (message.deleted_at) return "none";

  const meta = (message.metadata || {}) as Record<string, unknown>;
  const content = message.content || "";

  if (parseInboundInteractiveReply(meta)) return "block";
  if (parseOutboundCarouselDisplay(meta)) return "block";
  if (parseOutboundPollDisplay(meta)) return "block";
  if (parseOutboundInteractive(meta)) return "block";
  if (isInteractivePlaceholderContent(content, meta)) return "block";
  if (parseCatalogOrderDisplay(meta, content)) return "block";

  const metaType = meta.type as string | undefined;

  const isImagePlaceholder = isImagePlaceholderContent(content, metaType);
  const isVideoPlaceholder = isVideoPlaceholderContent(content, metaType);
  const isSharePlaceholder = isSharePlaceholderContent(content, metaType);
  const isStoryPlaceholder =
    metaType === "story_mention" && (!content || content === "[Menção no Story]");
  const isDocPlaceholder =
    metaType === "document" &&
    (!content || content === "[Documento enviado]" || content === "[Documento]");

  if (
    metaType === "audio" ||
    isSharePlaceholder ||
    isStoryPlaceholder ||
    isDocPlaceholder ||
    isImagePlaceholder ||
    isVideoPlaceholder
  ) {
    return "none";
  }

  return "inline";
}
